
<script>
export default {
  name: 'rex-tagpicker',
  props: {
    name: {
      type: String,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    hoResultsText: {
      type: String,
      default: () => 'Нет подходящих вариантов.'
    },
    placeholder: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
  },
  data: () => ({
    value: '',
  }),
  inject: ['$validator'],
  computed: {
    filtered() {
      return this.data.filter(option => option.name
        .toString()
        .toLowerCase()
        .indexOf(this.value.toLowerCase()) >= 0)
    },
    selected: {
      get() {
        const store = this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)

        return store.map(slug => ({
          name: this.data.find(item => item.slug === slug).name,
          slug
        }))
      },
      set(value) {
        const data = value.map(item => item.slug)

        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value: data
        })

        if (this.error !== null) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.field).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)
          this.$store.commit(`${this.storeModule}/${this.setterName}`, err)
        }

        this.$emit('onChange', {
          event: data,
          element: this.$vnode.elm
        })
      }
    },
    error() {
      const target = this.target.split('.')
      const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        .find(error => error.field === this.name)

      return err ? err.message : null
    },
  },
  methods: {
    selectOption(option) {
      if (option) {
        if (this.isSelected(option.slug)) {
          this.removeSelectedOption(option.slug)
        } else {
          this.selected = [...this.selected, option]
        }
      }
    },
    isSelected(slug) {
      return Boolean(this.selected.find(item => item.slug === slug))
    },
    removeSelectedOption(slug) {
      this.selected = this.selected.filter(item => item.slug !== slug)
    }
  }
}
</script>
<template>
  <div class="rex-tagpicker">
    <b-autocomplete
      v-model="value"
      v-validate="validate"
      :name="name"
      :disabled="disabled"
      :data="filtered"
      :placeholder="placeholder"
      field="name"
      :open-on-focus="true"
      :clear-on-select="true"
      @select="selectOption"
    >
      <template slot="empty">
        <p class="rex-tagpicker__option">
          {{ hoResultsText }}
        </p>
      </template>
      <template slot-scope="props">
        <p
          class="rex-tagpicker__option"
          :class="{
            'rex-tagpicker__option--selected': isSelected(props.option.slug)
          }"
        >
          {{ props.option.name }}
        </p>
      </template>
    </b-autocomplete>
    <b-tag
      v-for="item in selected"
      :key="item.slug"
      closable
      @close="removeSelectedOption(item.slug)"
    >
      {{ item.name }}
    </b-tag>
  </div>
</template>
